export default "__VITE_ASSET__DykQpj72__"